import styled from '@emotion/styled';
import zIndices from '../../../../../lib/zIndices';

const SinglePageDesktopNavWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${zIndices.desktopNavMenu};
`;

interface SinglePageDesktopNavContainerProps {
  children?: React.ReactNode;
}

const SinglePageDesktopNavContainer = ({
  children,
}: SinglePageDesktopNavContainerProps) => {
  return (
    <SinglePageDesktopNavWrapper data-testid="SinglePage__DesktopNav__Container">
      {children}
    </SinglePageDesktopNavWrapper>
  );
};

export default SinglePageDesktopNavContainer;
